import { css } from 'styled-components';
import COLORS from './colors';
import BREAKPOINTS from './breakpoints';
import { BOXSHADOWS } from './shadowstyles';

export  * from './typography';

import globalStyles from './global';
import { Size } from '../types';

export { COLORS, BREAKPOINTS, BOXSHADOWS, globalStyles };


export const scrollBarStyling = (size: Size.Small | Size.Medium = Size.Small) => css`
  
  ::-webkit-scrollbar {
    width: ${size == Size.Medium ? '6px' : '4px'};
    height: ${size == Size.Medium ? '6px' : '4px'};
    cursor: pointer;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: ${COLORS.neutral_100};
    border-radius: 6px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${COLORS.neutral_500};
    border-radius: 4px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: ${COLORS.primary_700};
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:active {
    background: ${COLORS.primary_800};
  }
`;

export {Z_INDEXES} from './z-indexes'

export * from './focus-styles';
